import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Bar = css`
  background: ${props => props.theme.carvana.grayFour};
  height: 4px;
  width: 28px;
`;

const TopBottomBar = css`
  content: '';
  left: 0;
  position: absolute;
  transition: transform 0.5s, top 0.5s, bottom 0.5s;
  ${Bar};
`;

const Wrapper = styled.div`
  cursor: pointer;
  height: 22px;
  margin-top: 6px;
  position: relative;
  width: 28px;

  &:after {
    bottom: ${props => (props.isShowing ? '9px' : 0)};
    transform: ${props =>
      props.isShowing ? 'rotate(-45deg)' : 'rotate(0deg)'};
    ${TopBottomBar};
  }

  &:before {
    top: ${props => (props.isShowing ? '9px' : 0)};
    transform: ${props => (props.isShowing ? 'rotate(45deg)' : 'rotate(0deg)')};
    ${TopBottomBar};
  }
`;

const MiddleBar = styled.div`
  opacity: ${props => (props.isShowing ? 0 : 1)};
  position: relative;
  top: 9px;
  transition: opacity 0.5s;
  ${Bar};
`;

class BarsToClose extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired
  };

  state = {
    isShowing: false
  };

  toggle = () => {
    const { onClick } = this.props;

    this.setState(
      ({ isShowing }) => ({ isShowing: !isShowing }),
      () => onClick()
    );
  };

  render() {
    const { isShowing } = this.state;

    return (
      <Wrapper onClick={this.toggle} isShowing={isShowing}>
        <MiddleBar isShowing={isShowing} />
      </Wrapper>
    );
  }
}

export default BarsToClose;
